import { useContext, useEffect, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { calculateNowTime } from "../../../services/sharedService";
import { Col } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import {
  calculateEffortRate,
  getIncomeForEffortRate,
} from "../../../helper/common";
import AuthContext from "../../../context/auth/AuthContext";

const CreatedTenant = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const { user: originalUser } = useContext(AuthContext);
  const { fetchCreatedTenant } = useContext(LandLordContext);

  const [tenantList, setTenantList] = useState([]);
  const [tenantListOriginal, setTenantListOriginal] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  useEffect(() => {
    fetchCreatedTenant()
      .then((res) => {
        const data = res.data;
        setTenantList(data);
        setTenantListOriginal(data);
      })
      .catch((err) => {
        console.log(err, "Error while fetching createdTenants");
      });
  }, []);

  useEffect(() => {
    const temp = tenantListOriginal?.filter(
      (val) =>
        val?.email?.includes(searchVal) ||
        val?.fname?.includes(searchVal) ||
        val?.lname?.includes(searchVal)
    );
    setTenantList(temp);
  }, [searchVal]);

  const calculateEffortRateInside = (user) => {
    const user_income = getIncomeForEffortRate(user);
    console.log(user?.fname, user_income, "checkvalhere123", originalUser);
    const temp_val = calculateEffortRate(user_income, originalUser, user);
    return temp_val?.effort_amount ?? "N/A";
  };

  const handleNavigateCreate = () => {
    navigate("/tenant-check/create");
  };

  return (
    <>
      <div className="d-flex gap-2 justify-content-between tenant-profile-search">
        <Col xl={4}>
          <input
            className="form-control small-padding"
            placeholder={_t("search")}
            onChange={(e) => setSearchVal(e.target.value)}
            value={searchVal}
            type="text"
          />
        </Col>
        <button
          className="btn btngreen small-padding"
          onClick={handleNavigateCreate}
        >
          + {_t("addTenantProfile")}
        </button>
      </div>
      <div>
        <table className="upcoming-table landlord-table bigtable_set">
          <thead>
            <tr className="first-row">
              <th>{_t("tenant")}</th>
              <th>{_t("effortRate")}</th>
              <th>{_t("added")}</th>
              <th></th>
            </tr>
          </thead>
          {Array.isArray(tenantList) && tenantList.length > 0 ? (
            <tbody>
              {tenantList.map((tenant) => (
                <>
                  <tr
                    className={`second-row`}
                    onClick={(e) => navigate(`/tenant-check/${tenant?._id}`)}
                  >
                    <td>
                      {tenant?.fname} {tenant?.lname}
                    </td>
                    <td>{calculateEffortRateInside(tenant)}</td>
                    <td>
                      {calculateNowTime(
                        tenant?.created_at,
                        localStorage.getItem("i18nextLng")
                      )}
                    </td>
                    <td>
                      <img src="/images/rightAngleArrow.svg" alt="" />
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          ) : null}
        </table>
        {(!Array.isArray(tenantList) || tenantList?.length == 0) && (
          <p className="text-center m-5">{_t("noEntriesFound")}</p>
        )}
      </div>
    </>
  );
};

export default CreatedTenant;
